// extracted by mini-css-extract-plugin
module.exports = {"contentGrid":"MyccaResourceImageUploaderPage_contentGrid__1MbRA"};